module.exports = __webpack_public_path__ + "static/media/burbujas-2_tex.2531ef1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/burbujas/burbujas-2_tex.png
// module id = 403
// module chunks = 0